export const homeTranslations = {
  en: {
    hero: {
      headline: 'Professional Sports Training',
      subheading: 'Elite Programs',
      tagline: 'A new perspective on your training',
      ourPackages: 'Our Packages',
      locations: 'Locations',
    },
    training: {
      heading: 'Experience Our World-Class Sports Camps',
      text: "Discover elite training programs designed for champions. Our world-class facilities and expert coaching staff provide the perfect environment for athletic excellence.",
      learnMore: 'Learn More',
    },
    about: {
      heading: 'Who we are?',
      description: 'A Bulgaria-based company specializes in organizing sports training camps throughout the country.',
      expanded: 'We provide comprehensive sports training solutions with state-of-the-art facilities, professional coaching, and complete camp management services.',
      learnMore: 'Learn More',
    },
    locations: {
      heading: 'Explore Our Locations',
      kranevo: { name: 'Kranevo', sports: 'Beach Sports', desc: "Located on Bulgaria's beautiful Black Sea coast, Kranevo offers a unique training environment combining beach sports with traditional venues.", address: 'Kranevo' },
      sofiaMladost: { name: 'Sofia, Mladost', sports: 'Basketball, Volleyball', desc: "Sports Hall 'Levski Sofia' is a modern sports hall and the only facility of its kind in Bulgaria.", address: 'Sofia, Mladost' },
      sofiaNsa: { name: 'Sofia, NSA', sports: 'Athletics', desc: 'The National Sports Academy (NSA) is a specialised higher education institution in Bulgaria with 75 years of history.', address: 'Sofia, NSA' },
      plovdiv: { name: 'Plovdiv', sports: 'Aquatic Sports', desc: 'A sports center featuring a 50m Olympic swimming pool with 10 lanes—ideal for swimming training camps.', address: 'Plovdiv' },
      sofiaBoyana: { name: 'Sofia, Boyana', sports: 'Multi-Sport', desc: 'A comprehensive multi-sport training facility in the Boyana district of Sofia, offering diverse training environments.', address: 'Sofia, Boyana' },
      viewDetails: 'View Details',
    },
    whyChooseUs: {
      heading: 'Why Choose Us',
      subheading: 'Organizing Training Camps in all Sports',
      features: [
        { title: 'Training Camps', desc: 'We organize professional training camps for all sports with full arrangements.' },
        { title: 'Locations in Bulgaria', desc: 'Choose from top sports facilities in Kranevo, Sofia, and Plovdiv.' },
        { title: 'Full Packages', desc: 'We handle accommodation, meals, transportation, and equipment.' },
        { title: 'International Sports Facilities', desc: 'Train at world-class venues equipped with modern amenities and professional standards.' },
      ],
    },
    packages: {
      heading: 'Explore Our Packages',
      subheading: 'Choose the Perfect Training Program for Your Team',
      popular: 'Popular',
      fullCampTitle: 'Full Camp Package',
      fullCampDesc: 'A complete all-inclusive training camp package that covers everything from facility booking and accommodation to meals and equipment.',
      includes: ['Booking sports facilities', 'Equipment rental', 'Accommodation', 'Meals and nutrition', 'Transportation'],
      viewDetails: 'View Details',
      discoverMore: 'Discover More',
    },
    stats: {
      tagline: 'A different perspective to your training - Champion Maker',
      camps: 'Camps',
      sports: 'Sports',
      locations: 'Locations',
      athletes: 'Athletes',
      bookNow: 'Book Now',
    },
    gallery: {
      heading: 'Explore Our Facilities',
    },
    finalCta: {
      heading: 'Ready to Elevate Your Training?',
      text: "Join elite athletes training at Bulgaria's finest facilities",
      button: 'Book Your Camp Now',
    },
  },
  ar: {
    hero: {
      headline: 'التدريب الرياضي الاحترافي',
      subheading: 'برامج النخبة',
      tagline: 'منظور جديد على تدريبك',
      ourPackages: 'باقاتنا',
      locations: 'المواقع',
    },
    training: {
      heading: 'استمتع بمعسكراتنا الرياضية عالمية المستوى',
      text: 'اكتشف برامج تدريب النخبة المصممة للأبطال. مرافقنا عالمية المستوى وطاقم التدريب الخبير يوفر البيئة المثالية للتميز الرياضي.',
      learnMore: 'اعرف المزيد',
    },
    about: {
      heading: 'من نحن؟',
      description: 'شركة مقرها بلغاريا تتخصص في تنظيم معسكرات التدريب الرياضي في جميع أنحاء البلاد.',
      expanded: 'نقدم حلول تدريب رياضية شاملة مع مرافق حديثة وتدريب احترافي وخدمات إدارة معسكرات كاملة.',
      learnMore: 'اعرف المزيد',
    },
    locations: {
      heading: 'استكشف مواقعنا',
      kranevo: { name: 'كرانييفو', sports: 'رياضات شاطئية', desc: 'تقع كرانييفو على الساحل الجميل للبحر الأسود في بلغاريا، وتوفر بيئة تدريب فريدة تجمع بين الرياضات الشاطئية والمرافق التقليدية.', address: 'كرانييفو' },
      sofiaMladost: { name: 'صوفيا، ملادوست', sports: 'كرة السلة، الكرة الطائرة', desc: 'قاعة ليفسكي صوفيا الرياضية هي قاعة رياضية حديثة والمنشأة الوحيدة من نوعها في بلغاريا.', address: 'صوفيا، ملادوست' },
      sofiaNsa: { name: 'صوفيا، الأكاديمية الوطنية', sports: 'ألعاب القوى', desc: 'الأكاديمية الوطنية للرياضة (NSA) هي مؤسسة تعليم عالي متخصصة في بلغاريا بتاريخ 75 عامًا.', address: 'صوفيا، الأكاديمية الوطنية' },
      plovdiv: { name: 'بلوفديف', sports: 'الرياضات المائية', desc: 'مركز رياضي يضم مسبح أولمبي طوله 50 مترًا و10 حارات — مثالي لمعسكرات تدريب السباحة.', address: 'بلوفديف' },
      sofiaBoyana: { name: 'صوفيا، بويانا', sports: 'متعدد الرياضات', desc: 'منشأة تدريب رياضية شاملة في منطقة بويانا في صوفيا، توفر بيئات تدريب متنوعة.', address: 'صوفيا، بويانا' },
      viewDetails: 'عرض التفاصيل',
    },
    whyChooseUs: {
      heading: 'لماذا تختارنا',
      subheading: 'تنظيم معسكرات التدريب في جميع الرياضات',
      features: [
        { title: 'معسكرات التدريب', desc: 'ننظم معسكرات تدريب احترافية لجميع الرياضات مع ترتيبات كاملة.' },
        { title: 'مواقع في بلغاريا', desc: 'اختر من أفضل المرافق الرياضية في كرانييفو وصوفيا وبلوفديف.' },
        { title: 'باقات كاملة', desc: 'نتعامل مع الإقامة والوجبات والنقل والمعدات.' },
        { title: 'مرافق رياضية دولية', desc: 'تدرب في أماكن عالمية المستوى مجهزة بمرافق حديثة ومعايير احترافية.' },
      ],
    },
    packages: {
      heading: 'استكشف باقاتنا',
      subheading: 'اختر برنامج التدريب المثالي لفريقك',
      popular: 'الأكثر شعبية',
      fullCampTitle: 'باقة المعسكر الكامل',
      fullCampDesc: 'باقة معسكر تدريب شامل كاملة تغطي كل شيء من حجز المرافق والإقامة إلى الوجبات والمعدات.',
      includes: ['حجز المرافق الرياضية', 'تأجير المعدات', 'الإقامة', 'الوجبات والتغذية', 'النقل'],
      viewDetails: 'عرض التفاصيل',
      discoverMore: 'اكتشف المزيد',
    },
    stats: {
      tagline: 'منظور مختلف لتدريبك - صناع الأبطال',
      camps: 'معسكرات',
      sports: 'رياضات',
      locations: 'مواقع',
      athletes: 'رياضيون',
      bookNow: 'احجز الآن',
    },
    gallery: {
      heading: 'استكشف مرافقنا',
    },
    finalCta: {
      heading: 'مستعد لرفع مستوى تدريبك؟',
      text: 'انضم إلى رياضيين النخبة يتدربون في أفضل مرافق بلغاريا',
      button: 'احجز معسكرك الآن',
    },
  },
};
